export default "__VITE_ASSET__Dnbjiqch__"